<template>
  <div class="notice-bar" v-if="text">
    <span class="notice-bar__label">最新公告</span>
    <div class="notice-bar__scroll">
      <div class="notice-bar__track">
        <span class="notice-bar__text">{{ text }}</span>
        <span class="notice-bar__text">{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchNoticeList } from '@/api/notice'

export default {
  name: 'NoticeBar',
  data() {
    return { text: '' }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      try {
        const siteId = process.env.VUE_APP_SITE_ID || 'default'
        const res = await fetchNoticeList(siteId)
        const data = res.data
        const list = Array.isArray(data) ? data : (data && Array.isArray(data.data) ? data.data : [])
        this.text = list.map(n => n.content).join(' ｜ ')
        const domain = list.find(n => n.siteDomain)?.siteDomain || ''
        this.$emit('domain-loaded', domain)
      } catch (e) {
        // silent
      }
    }
  }
}
</script>

<style scoped>
.notice-bar {
  display: flex;
  align-items: center;
  margin: 0.3rem 0 clamp(0.375rem, 2vw, 0.5rem);
  padding: 0;
  //background: linear-gradient(90deg, #fff8e1, #fff3e0);
  border-radius: clamp(0.35rem, 1.5vw, 0.5rem);
  overflow: hidden;
  border: 0.1rem solid #ffe0b2;
}
.notice-bar__label {
  flex: 0 0 auto;
  align-self: stretch;
  display: flex;
  align-items: center;
  background: #f3a404;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 0 0.6rem;
}
.notice-bar__scroll {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  padding: clamp(0.375rem, 2vw, 0.5rem) clamp(0.375rem, 2vw, 0.5rem) clamp(0.375rem, 2vw, 0.5rem) 0.5rem;
}
.notice-bar__track {
  display: inline-block;
  white-space: nowrap;
  animation: notice-scroll 17s linear infinite;
}
.notice-bar__text {
  font-size: clamp(0.875rem, 3vw, 1rem);
  color: #000;
  font-weight: bold;
  padding-right: 2rem;
}
@keyframes notice-scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
</style>
